import AnimatedSection from '../../../components/base/AnimatedSection';

export default function CommunitySection() {
  return (
    <section className="py-24 bg-gradient-to-b from-slate-800 to-slate-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          <AnimatedSection animation="fadeRight">
            <div>
              <div className="inline-flex items-center gap-2 px-5 py-2 bg-cyan-500/10 backdrop-blur-sm rounded-full text-cyan-400 mb-6 border border-cyan-500/30">
                <i className="ri-community-line"></i>
                <span className="text-sm font-semibold">社区</span>
              </div>
              <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
                OpenClaw 中国微信交流群
              </h2>
              <p className="text-base sm:text-xl text-gray-300 mb-6 sm:mb-8 leading-relaxed">
                更快上手，更少踩坑；有问题直接问
              </p>
              
              <ul className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
                {[
                  '安装/更新/配对问题互助答疑',
                  '网关运维、通道接入、插件实践分享',
                  '关键变更与使用建议同步（少走弯路）',
                  '支持更新与使用建议同步（少走弯路）',
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3 text-gray-300 text-sm sm:text-base">
                    <i className="ri-checkbox-circle-fill text-cyan-400 text-lg sm:text-xl mt-0.5 flex-shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <div className="bg-cyan-500/10 border border-cyan-500/30 rounded-xl p-4 sm:p-6">
                <p className="text-cyan-400 text-xs sm:text-sm leading-relaxed">
                  <i className="ri-information-line mr-2"></i>
                  微信扫码加入（请务必备注：行业 + 学习目的，提高通过率）
                </p>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection animation="fadeLeft" delay={200}>
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-5 sm:p-8 border border-cyan-500/30 shadow-2xl shadow-cyan-500/20">
              <div className="aspect-square bg-white rounded-xl p-4 sm:p-6 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/335e3e62ea46a4ee8fffcd870552cca1/c25c2cb1e24f39a307981851ee478810.jpeg" 
                  alt="OpenClaw 中国微信交流群二维码"
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-center text-gray-400 text-xs sm:text-sm mt-4 sm:mt-6">
                点击放大 · 建议用微信"扫一扫"
              </p>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}